import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import Events from './pages/Events';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import './index.css';
import './fonts.css';
import Gallery from './pages/Gallery';
import Library from './pages/Library';
import BibleStudy from './pages/ministries/BibleStudy';
import HealingParty from './pages/ministries/HealingParty';
import LifeInTheSpirit from './pages/ministries/LifeInTheSpirit';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import PopMyCherry from './pages/events/PopMyCherry';
import BirthdayBibleBrunch from './pages/events/BirthdayBibleBrunch';
import HiddenPage from './pages/events/hiddenPage';
import TitoTheWriterPage from './pages/titothewriter';
import Volunteer from './pages/events/Volunteer';
import Admin from './pages/Admin';
import Private001 from './pages/private/001';
import UnveilPage from './pages/UnveilPage';
import Live from './pages/Live';
import Ask from './pages/Ask';
import Study from './pages/Study';
import VolunteerPage from './pages/events/Volunteer2';
import BootCamp from './pages/BootCamp';
import TestimonialsPage from './pages/TestimonialsPage';
import QuizPage from './pages/QuizPage';
import BioDataForm from './pages/BioDataForm';
import VolunteerForm from './pages/VolunteerForm';
import PartnerForm from './pages/PartnerForm';
import ClientBooking from './pages/healing-pavilion';
import ClientBookingPage from './pages/healing-pavilion/client-booking';
import Magazine from './pages/Magazine';
import BstMasterclass from './pages/BstMasterclass';
import VIPRegistration from './pages/private/001';

function App() {
  const isDev = process.env.NODE_ENV === "development";
  return isDev ? <React_App /> : <WordPress_App />;
}

function useCurrentPageSlug() {
  const location = useLocation();
  return location.pathname.replace(/^\/|\/$/g, "");
}


function WordPress_App() {
  const currentPageSlug = window.wpData?.slug || "home"; // Default to "home" if no slug is found

  let ComponentToRender;
  switch (currentPageSlug) {
    case 'home':
      ComponentToRender = <Home />;
      break;
    case 'about':
      ComponentToRender = <About />;
      break;
    case 'library':
      ComponentToRender = <Library />;
      break;
    case 'gallery':
      ComponentToRender = <Gallery />;
      break;
    case 'contact':
      ComponentToRender = <Contact />;
      break;
    case 'login':
      ComponentToRender = <Login />;
      break;
    case 'register':
      ComponentToRender = <Register />;
      break;
    case 'profile':
      ComponentToRender = <Profile />;
      break;

    // Bible Study
    case 'bible-study':
    case 'bs':
      ComponentToRender = <BibleStudy />;
      break;

    // Healing Party
    case 'healing-party':
    case 'hp':
      ComponentToRender = <HealingParty />;
      break;

    // Life In The Spirit
    case 'life-in-the-spirit':
    case 'lits':
      ComponentToRender = <LifeInTheSpirit />;
      break;

    //pop-my-cherry
    case 'pop-my-cherry':
      ComponentToRender = <PopMyCherry />;
      break;

    // Life In The Spirit
    case 'birthday-bible-brunch':
    case 'bbb':
      ComponentToRender = <BirthdayBibleBrunch />;
      break;

      case 'hiddenpage':
      ComponentToRender = <Home />;
      break;

      case 'titothewriter':
      ComponentToRender = <TitoTheWriterPage />;
      break;

      case 'volunteer':
      ComponentToRender = <VolunteerPage />;
      break;

      case 'boot-camp':
      ComponentToRender = <BootCamp />;
      break;

      case 'unveil':
      ComponentToRender = <UnveilPage />;
      break;

      case 'live':
      ComponentToRender = <Live />;
      break;

      case 'ask':
      ComponentToRender = <Ask />;
      break;

      case 'study':
      ComponentToRender = <Study />;
      break;

      case 'testimonials':
      ComponentToRender = <TestimonialsPage />;
      break;

      case 'quiz':
      ComponentToRender = <QuizPage />;
      break;

      case 'admin':
      ComponentToRender = <Admin />;
      break;

      case 'bio-data-form':
      ComponentToRender = <BioDataForm />;
      break;

      case 'volunteer-form':
      ComponentToRender = <VolunteerForm />;
      break;

      case 'bst-masterclass':
      ComponentToRender = <BstMasterclass />;
      break;

      case 'partner-form':
      ComponentToRender = <PartnerForm />;
      break;

      case 'vip-pr1vate-link51094':
      ComponentToRender = <VIPRegistration />;
      break;

      case 'the-healing-pavilion':
      ComponentToRender = <ClientBooking />;
      break;

      case 'client-booking':
      ComponentToRender = <ClientBookingPage />;
      break;

      case 'magazine':
      ComponentToRender = <Magazine />;
      break;

    default:
      ComponentToRender = <Home />;
  }

  return <Layout currentPageSlug={currentPageSlug}>{ComponentToRender}</Layout>;
}

function React_App() {
  return (
    <Router>
      <React_App_Layout />
    </Router>
  );
}

function React_App_Layout() {
  const currentPageSlug = useCurrentPageSlug();

  return (
    <Layout currentPageSlug={currentPageSlug}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/library" element={<Library />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/bible-study" element={<BibleStudy />} />
        <Route path="/healing-party" element={<HealingParty />} />
        <Route path="/life-in-the-spirit" element={<LifeInTheSpirit />} />
        <Route path="/pop-my-cherry" element={<PopMyCherry />} />
        <Route path="/birthday-bible-brunch" element={<BirthdayBibleBrunch />} />
        <Route path="/boot-camp" element={<BootCamp />} />
        <Route path="/titothewriter" element={<TitoTheWriterPage />}/>
        <Route path="/volunteer" element={<VolunteerPage />}/>
        <Route path="/unveil" element={<UnveilPage />}/>
        <Route path="/live" element={<Live />}/>
        <Route path="/ask" element={<Ask />}/>
        <Route path="/study" element={<Study />}/>
        <Route path="/testimonials" element={<TestimonialsPage />}/>
        <Route path="/quiz" element={<QuizPage />}/>
        <Route path="/admin" element={<Admin />}/>
        <Route path="/bio-data-form" element={<BioDataForm />}/>
        <Route path="/volunteer-form" element={<VolunteerForm />}/>
        <Route path="/bst-masterclass" element={<BstMasterclass />}/>
        <Route path="/partner-form" element={<PartnerForm />}/>
        <Route path="/hiddenpage" element={<Home />} />
        <Route path="/vip-pr1vate-link51094" element={<VIPRegistration />} />
        <Route path="/the-healing-pavilion" element={<ClientBooking />} />
        <Route path="/client-booking" element={<ClientBookingPage />} />
        <Route path="/magazine" element={<Magazine />} />
      </Routes>
    </Layout>
  );
}


// ReactDOM.render(<App />, document.getElementById('root'));
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
